import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';

import {
	CANCEL_BUTTON_TEXT,
	getModalTitle as baseGetModalTitle,
	MODAL_DESCRIPTIONS,
	ModalType,
	SAVE_BUTTON_TEXT
} from '../shared/constants';

export { SAVE_BUTTON_TEXT, CANCEL_BUTTON_TEXT };

export const MODAL_DESCRIPTION = MODAL_DESCRIPTIONS[ModalType.ADD];

/**
 * Generate modal title for add label modal
 */
export const getModalTitle = (testRows: IWebSdkTest[]): string =>
	baseGetModalTitle(ModalType.ADD, testRows);
